/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useEffect} from 'react';
import Cookies from 'js-cookie';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {analyticsPromise} from 'utils/firebase';

import {ACCESS_TOKEN_COOKIE_KEY, APP_VERSION_COOKIE_KEY, SOURCE_KEY} from 'constants/cookie';
import {
  isAuthenticated,
  Analytics,
  setupGlobalErrorHandlers,
  cleanupGlobalErrorHandlers,
} from 'utils';
import env from 'env';
import {
  ClientAppCommunicationContext,
  ClientAppCommsHandlers,
} from './context/CommunicationsContext';
import {appendQueryParamToUrl} from 'utils/urlUtils';
import ErrorBoundary from 'components/common/ErrorBoundary';

import Router from 'Router';

const analytics = analyticsPromise?.then((x) => {
  console.log(x);
  return x;
});

const App = () => {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const authToken = searchParams.get('token');
  const redirectTo = searchParams.get('redirect_to');
  const newAppVersion = searchParams.get('new_app_version');
  const appVersion = searchParams.get('app_version');
  const source = searchParams.get(SOURCE_KEY);
  const wlId = searchParams.get('wl_id');

  // This is to preserve the behavior when kyc opened in client web
  const redirectUrlWithSource =
    source && redirectTo ? appendQueryParamToUrl(redirectTo, SOURCE_KEY, source) : redirectTo;

  // Preserve branding across the token -> WEALTHY_KYC_URL redirect round trip.
  const kycUrlWithWlId = wlId
    ? appendQueryParamToUrl(env.WEALTHY_KYC_URL, 'wl_id', wlId)
    : env.WEALTHY_KYC_URL;

  useEffect(() => {
    Analytics.initializeSegment();
    setupGlobalErrorHandlers();

    if (source) {
      Cookies.set(SOURCE_KEY, source);
    }

    if (appVersion) {
      Cookies.set(APP_VERSION_COOKIE_KEY, appVersion);
    }

    // Cleanup function to remove error handlers when component unmounts
    return () => {
      cleanupGlobalErrorHandlers();
    };
  }, []);

  if (!isAuthenticated()) {
    if (!authToken) {
      return <h1>Page not Available</h1>;
    } else {
      let token = String(authToken).replace('%20', ' ');
      Cookies.set(ACCESS_TOKEN_COOKIE_KEY, token);
      sessionStorage.setItem('redirectTo', redirectUrlWithSource);
      sessionStorage.setItem('newAppVersion', newAppVersion);
      window.location.assign(kycUrlWithWlId);
    }
  } else {
    if (isAuthenticated() && authToken && !!authToken.length) {
      let token = String(authToken).replace('%20', ' ');
      Cookies.set(ACCESS_TOKEN_COOKIE_KEY, token);
      sessionStorage.setItem('redirectTo', redirectUrlWithSource);
      sessionStorage.setItem('newAppVersion', newAppVersion);
      window.location.assign(kycUrlWithWlId);
    } else {
      return (
        <>
          <head>
            <script>
              {(function (c, l, a, r, i, t, y) {
                c[a] =
                  c[a] ||
                  function () {
                    (c[a].q = c[a].q || []).push(arguments);
                  };
                t = l.createElement(r);
                t.async = 1;
                t.src = 'https://www.clarity.ms/tag/' + i;
                y = l.getElementsByTagName(r)[0];
                y.parentNode.insertBefore(t, y);
              })(window, document, 'clarity', 'script', env.MS_CLARITY_CODE)}
            </script>
          </head>
          <ErrorBoundary>
            <ClientAppCommunicationContext.Provider value={new ClientAppCommsHandlers()}>
              <ToastContainer />
              <Router wlId={wlId} />
            </ClientAppCommunicationContext.Provider>
          </ErrorBoundary>
        </>
      );
    }
  }
};

export default App;
